module.exports = __webpack_public_path__ + "img/9791187700128.6ef7ee86.jpg";